<template>
  <div :class="pageClass">
    <div class="report-header d-flex flex-row justify-content-between align-items-center bg-faded p-3">
      <div>
        <img src="/static/img/logo-lg.png" class="report-logo">
      </div>
      <div class="col-md-auto">
        <h2>{{ 'Welding Report' | translate }}</h2>
      </div>
      <div>
        <p>{{ currentDate }}</p>
      </div>
    </div>
    <div class="report-body p-3">
      <joint-map :enableOverlay="false" :zoom="14" mapStyle="min-width: 1072px" :joints="reportRows"></joint-map>
    </div>
    <div class="report-footer bg-faded p-2">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <p>
            <b>{{ 'Created by:' | translate }}</b> {{ currentUser.firstname }} {{ currentUser.surname }}</br>
            <b>{{ 'Company:' | translate }}</b> {{ companyName }}
            <span v-if="currentReportName">
              </br>
              <b>{{ 'Report Name:' | translate }}</b> {{ currentReportName }}</br>
            </span>
          </p>
        </div>
        <div>
          <p><b>{{ 'Page:' | translate }}</b> 1 {{ 'of' | translate }} {{ noOfPages + 1 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import JointMap from './JointMap'

export default {
  components: {
    JointMap
  },
  props: ['reportRows', 'noOfPages'],
  data: function () {
    return {
      currentDate: null
    }
  },
  computed: {
    ...mapGetters([
      'currentCompany',
      'currentUser',
      'currentReportName'
    ]),
    pageClass: function () {
      return 'report-page page-' + this.pageNo
    },
    companyName: function () {
      return this.$store.getters.currentUser.companies.find(x => x.id === this.$store.getters.currentCompany).name
    }
  },
  mounted: function () {
    var cd = new Date()
    this.currentDate = cd.toUTCString()
  },
  methods: {
    columnName: function (key) {
      return 'column-' + key
    }
  },
  filters: {
    filterThat: function (val, key) {
      if (key === 'name') {
        return val.slice(-3)
      } else {
        return val
      }
    }
  }
}
</script>
<style>

.report-page {
  border: 1px solid #f0f0f0
}

.report-logo {
  max-width: 100px;
}

.report-header {
  height: 30mm
}

.report-body {
  height: 160mm
}

.report-footer {
  height: 20mm
}

.column-joint_id {
  display: none
}

.column-type_no {
  display: none
}

</style>


// WEBPACK FOOTER //
// JointReportCoverPage.vue?27f25550